import {Link} from 'react-router-dom';

export default function Header({
    heading,
    paragraph,
    linkName,
    linkUrl=""
}){
    return(
        <div className="mb-10">
            <div className="flex justify-center">
                
            </div>
            <h2 className=" text-center text-3xl font-extrabold text-gray-900">
                {heading}
            </h2>
            <p className="text-center text-sm text-gray-600 mt-5">
            {paragraph} {' '}
            <Link to={linkUrl} className="font-medium text-[#ee5535] hover:text-[#af3921] text-2xl relative top-1">
                {linkName}
            </Link>
            </p>
        </div>
    )
}